import { render, staticRenderFns } from "./CardDialog.vue?vue&type=template&id=e086c2c8&scoped=true"
import script from "./CardDialog.vue?vue&type=script&lang=js"
export * from "./CardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e086c2c8",
  null
  
)

export default component.exports